<fgb-account-layout titleKey="account.edit-questions.title" titleDefault="Edit Questions">
  <fgb-account-panel titleKey="account.edit-questions.title" titleDefault="Edit Questions">
    <fgbcl-edit-questions [comfortEdit]="false"></fgbcl-edit-questions>
  </fgb-account-panel>
</fgb-account-layout>
